import React, { useState } from 'react';
import { TrendingUpIcon, CalendarIcon, WrenchIcon, XIcon } from 'lucide-react';
import { SuccessNotification } from '../shared/SuccessNotification';
interface MaintenanceFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  initialAsset?: string;
}
const MaintenanceFormModal: React.FC<MaintenanceFormModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  initialAsset = ''
}) => {
  const [formData, setFormData] = useState({
    assetId: initialAsset,
    assetName: '',
    serviceDate: new Date().toISOString().split('T')[0],
    vendor: '',
    cost: '',
    description: '',
    status: 'Dijadwalkan',
    healthScore: '100'
  });
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
    setFormData({
      assetId: '',
      assetName: '',
      serviceDate: new Date().toISOString().split('T')[0],
      vendor: '',
      cost: '',
      description: '',
      status: 'Dijadwalkan',
      healthScore: '100'
    });
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-2254">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col" data-id="element-2255">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center bg-neutral-light" data-id="element-2256">
          <h2 className="text-xl font-bold text-secondary flex items-center" data-id="element-2257">
            <WrenchIcon size={20} className="mr-2 text-primary" data-id="element-2258" />
            Catat Pemeliharaan
          </h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-200 transition-colors" data-id="element-2259">
            <XIcon size={20} className="text-gray-500" data-id="element-2260" />
          </button>
        </div>
        <div className="overflow-y-auto p-6 flex-grow" data-id="element-2261">
          <form id="maintenance-form" onSubmit={handleSubmit} className="space-y-4" data-id="element-2262">
            <div className="space-y-1" data-id="element-2263">
              <label className="text-sm font-medium text-gray-700" data-id="element-2264">
                ID Aset <span className="text-red-500" data-id="element-2265">*</span>
              </label>
              <input type="text" required value={formData.assetId} onChange={e => setFormData({
              ...formData,
              assetId: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Contoh: AST-001" data-id="element-2266" />
            </div>
            <div className="space-y-1" data-id="element-2267">
              <label className="text-sm font-medium text-gray-700" data-id="element-2268">
                Nama Aset
              </label>
              <input type="text" value={formData.assetName} onChange={e => setFormData({
              ...formData,
              assetName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Nama aset (opsional)" data-id="element-2269" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-2270">
              <div className="space-y-1" data-id="element-2271">
                <label className="text-sm font-medium text-gray-700" data-id="element-2272">
                  Tanggal Servis <span className="text-red-500" data-id="element-2273">*</span>
                </label>
                <input type="date" required value={formData.serviceDate} onChange={e => setFormData({
                ...formData,
                serviceDate: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-2274" />
              </div>
              <div className="space-y-1" data-id="element-2275">
                <label className="text-sm font-medium text-gray-700" data-id="element-2276">
                  Vendor
                </label>
                <input type="text" value={formData.vendor} onChange={e => setFormData({
                ...formData,
                vendor: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Nama vendor pelaksana" data-id="element-2277" />
              </div>
            </div>
            <div className="space-y-1" data-id="element-2278">
              <label className="text-sm font-medium text-gray-700" data-id="element-2279">Biaya</label>
              <div className="relative" data-id="element-2280">
                <span className="absolute left-3 top-2 text-gray-500 text-sm" data-id="element-2281">
                  Rp
                </span>
                <input type="text" value={formData.cost} onChange={e => setFormData({
                ...formData,
                cost: e.target.value
              })} className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="0" data-id="element-2282" />
              </div>
            </div>
            <div className="space-y-1" data-id="element-2283">
              <label className="text-sm font-medium text-gray-700" data-id="element-2284">
                Deskripsi Pekerjaan
              </label>
              <textarea rows={3} value={formData.description} onChange={e => setFormData({
              ...formData,
              description: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Rincian pekerjaan yang dilakukan..." data-id="element-2285" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-2286">
              <div className="space-y-1" data-id="element-2287">
                <label className="text-sm font-medium text-gray-700" data-id="element-2288">
                  Status <span className="text-red-500" data-id="element-2289">*</span>
                </label>
                <select value={formData.status} onChange={e => setFormData({
                ...formData,
                status: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-2290">
                  <option value="Dijadwalkan" data-id="element-2291">Dijadwalkan</option>
                  <option value="Dalam Proses" data-id="element-2292">Dalam Proses</option>
                  <option value="Selesai" data-id="element-2293">Selesai</option>
                </select>
              </div>
              <div className="space-y-1" data-id="element-2294">
                <label className="text-sm font-medium text-gray-700" data-id="element-2295">
                  Health Score (0-100)
                </label>
                <input type="number" min="0" max="100" value={formData.healthScore} onChange={e => setFormData({
                ...formData,
                healthScore: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-2296" />
              </div>
            </div>
          </form>
        </div>
        <div className="p-4 border-t border-gray-200 flex justify-end space-x-2 bg-gray-50" data-id="element-2297">
          <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-100" data-id="element-2298">
            Batal
          </button>
          <button type="submit" form="maintenance-form" className="px-4 py-2 bg-primary text-secondary rounded-md text-sm font-medium hover:bg-opacity-90" data-id="element-2299">
            Simpan
          </button>
        </div>
      </div>
    </div>;
};
export const Maintenance: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notification, setNotification] = useState({
    show: false,
    message: ''
  });
  const [prefilledAsset, setPrefilledAsset] = useState('');
  const handleOpenModal = (assetId = '') => {
    setPrefilledAsset(assetId);
    setIsModalOpen(true);
  };
  const handleSubmit = (data: any) => {
    setIsModalOpen(false);
    setNotification({
      show: true,
      message: `Pemeliharaan untuk ${data.assetId} berhasil dicatat`
    });
  };
  const handleScheduleView = () => {
    setNotification({
      show: true,
      message: 'Jadwal pemeliharaan berhasil dimuat'
    });
  };
  return <div className="space-y-4" data-id="element-2300">
      <div className="flex items-center justify-between mb-4" data-id="element-2301">
        <h1 className="text-2xl font-bold text-secondary flex items-center" data-id="element-2302">
          <WrenchIcon size={24} className="mr-2" data-id="element-2303" />
          Pemeliharaan & Prediksi Kesehatan
        </h1>
        <div className="flex space-x-2" data-id="element-2304">
          <button onClick={handleScheduleView} className="bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90" data-id="element-2305">
            Jadwal Pemeliharaan
          </button>
          <button onClick={() => handleOpenModal()} className="bg-primary text-secondary px-4 py-2 rounded-md hover:bg-opacity-90 font-medium" data-id="element-2306">
            + Catat Pemeliharaan
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-id="element-2307">
        <div className="lg:col-span-2 bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-2308">
          <div className="p-3 border-b border-gray-200 bg-neutral-light flex justify-between items-center" data-id="element-2309">
            <h2 className="font-bold text-secondary" data-id="element-2310">
              Log Pemeliharaan Terbaru
            </h2>
            <div className="flex items-center" data-id="element-2311">
              <select className="text-sm border border-gray-300 rounded px-2 py-1" data-id="element-2312">
                <option value="all" data-id="element-2313">Semua Kategori</option>
                <option value="hardware" data-id="element-2314">Perangkat Keras</option>
                <option value="software" data-id="element-2315">Software</option>
                <option value="vehicles" data-id="element-2316">Kendaraan</option>
                <option value="buildings" data-id="element-2317">Bangunan</option>
              </select>
            </div>
          </div>
          <div className="overflow-x-auto" data-id="element-2318">
            <table className="w-full" data-id="element-2319">
              <thead className="bg-neutral-light" data-id="element-2320">
                <tr data-id="element-2321">
                  <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-2322">
                    ID Aset
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-2323">
                    Nama Aset
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-2324">
                    Tanggal Servis
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-2325">
                    Vendor
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-2326">
                    Biaya
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-2327">
                    Status
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-2328">
                    Health Score
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-2329">
                <tr className="hover:bg-neutral-light" data-id="element-2330">
                  <td className="px-4 py-3 text-sm text-gray-900" data-id="element-2331">AST-001</td>
                  <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-2332">
                    Server Database Utama
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-2333">
                    2026-01-15
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-2334">
                    PT Teknologi Aman
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-2335">
                    Rp 15.000.000
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-2336">
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-2337">
                      Selesai
                    </span>
                  </td>
                  <td className="px-4 py-3" data-id="element-2338">
                    <div className="flex items-center" data-id="element-2339">
                      <div className="w-16 h-2 bg-gray-200 rounded-full mr-2" data-id="element-2340">
                        <div className="h-2 bg-green-500 rounded-full" style={{
                        width: '85%'
                      }} data-id="element-2341"></div>
                      </div>
                      <span className="text-xs font-medium" data-id="element-2342">85%</span>
                    </div>
                  </td>
                </tr>
                <tr className="hover:bg-neutral-light" data-id="element-2343">
                  <td className="px-4 py-3 text-sm text-gray-900" data-id="element-2344">AST-002</td>
                  <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-2345">
                    Router Backbone STIN
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-2346">
                    2025-12-28
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-2347">
                    PT Jaringan Aman
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-2348">
                    Rp 8.500.000
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-2349">
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-2350">
                      Selesai
                    </span>
                  </td>
                  <td className="px-4 py-3" data-id="element-2351">
                    <div className="flex items-center" data-id="element-2352">
                      <div className="w-16 h-2 bg-gray-200 rounded-full mr-2" data-id="element-2353">
                        <div className="h-2 bg-yellow-500 rounded-full" style={{
                        width: '65%'
                      }} data-id="element-2354"></div>
                      </div>
                      <span className="text-xs font-medium" data-id="element-2355">65%</span>
                    </div>
                  </td>
                </tr>
                <tr className="hover:bg-neutral-light" data-id="element-2356">
                  <td className="px-4 py-3 text-sm text-gray-900" data-id="element-2357">AST-004</td>
                  <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-2358">
                    Firewall Pusat Data
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-2359">
                    2026-01-05
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-2360">
                    PT Keamanan Siber
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-2361">
                    Rp 12.300.000
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-2362">
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-2363">
                      Dalam Proses
                    </span>
                  </td>
                  <td className="px-4 py-3" data-id="element-2364">
                    <div className="flex items-center" data-id="element-2365">
                      <div className="w-16 h-2 bg-gray-200 rounded-full mr-2" data-id="element-2366">
                        <div className="h-2 bg-red-500 rounded-full" style={{
                        width: '35%'
                      }} data-id="element-2367"></div>
                      </div>
                      <span className="text-xs font-medium" data-id="element-2368">35%</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="p-3 border-t border-gray-200 flex items-center justify-between" data-id="element-2369">
            <div className="text-sm text-gray-700" data-id="element-2370">
              Menampilkan 3 dari 87 log pemeliharaan
            </div>
            <div className="flex items-center space-x-2" data-id="element-2371">
              <button className="px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50" data-id="element-2372">
                Sebelumnya
              </button>
              <button className="px-3 py-1 bg-secondary text-white rounded-md text-sm" data-id="element-2373">
                1
              </button>
              <button className="px-3 py-1 border border-gray-300 rounded-md text-sm" data-id="element-2374">
                2
              </button>
              <button className="px-3 py-1 border border-gray-300 rounded-md text-sm" data-id="element-2375">
                3
              </button>
              <button className="px-3 py-1 border border-gray-300 rounded-md text-sm" data-id="element-2376">
                Berikutnya
              </button>
            </div>
          </div>
        </div>
        <div className="space-y-4" data-id="element-2377">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-2378">
            <div className="p-3 border-b border-gray-200 bg-neutral-light flex items-center justify-between" data-id="element-2379">
              <h2 className="font-bold text-secondary flex items-center" data-id="element-2380">
                <TrendingUpIcon size={18} className="mr-2 text-accent-info" data-id="element-2381" />
                Prediksi AI Health Score
              </h2>
              <span className="text-xs bg-accent-info text-white px-2 py-1 rounded" data-id="element-2382">
                Powered by AI
              </span>
            </div>
            <div className="p-4" data-id="element-2383">
              <div className="space-y-3" data-id="element-2384">
                <div className="bg-neutral-light p-3 rounded-lg" data-id="element-2385">
                  <div className="flex justify-between items-center mb-2" data-id="element-2386">
                    <h3 className="font-medium text-secondary text-sm" data-id="element-2387">
                      Server Database Utama
                    </h3>
                    <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-2388">
                      85%
                    </span>
                  </div>
                  <div className="h-1 w-full bg-gray-200 rounded-full mb-2" data-id="element-2389">
                    <div className="h-1 bg-green-500 rounded-full" style={{
                    width: '85%'
                  }} data-id="element-2390"></div>
                  </div>
                  <p className="text-xs text-gray-600" data-id="element-2391">
                    Prediksi perlu pemeliharaan:{' '}
                    <span className="font-medium" data-id="element-2392">Juli 2026</span>
                  </p>
                </div>
                <div className="bg-neutral-light p-3 rounded-lg" data-id="element-2393">
                  <div className="flex justify-between items-center mb-2" data-id="element-2394">
                    <h3 className="font-medium text-secondary text-sm" data-id="element-2395">
                      Router Backbone STIN
                    </h3>
                    <span className="text-xs bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full" data-id="element-2396">
                      65%
                    </span>
                  </div>
                  <div className="h-1 w-full bg-gray-200 rounded-full mb-2" data-id="element-2397">
                    <div className="h-1 bg-yellow-500 rounded-full" style={{
                    width: '65%'
                  }} data-id="element-2398"></div>
                  </div>
                  <p className="text-xs text-gray-600" data-id="element-2399">
                    Prediksi perlu pemeliharaan:{' '}
                    <span className="font-medium text-accent-red" data-id="element-2400">
                      Maret 2026
                    </span>
                  </p>
                  <button onClick={() => handleOpenModal('Router Backbone STIN')} className="mt-2 bg-accent-info text-white px-2 py-1 rounded text-xs w-full hover:bg-opacity-90" data-id="element-2401">
                    Jadwalkan Sekarang
                  </button>
                </div>
                <div className="bg-neutral-light p-3 rounded-lg" data-id="element-2402">
                  <div className="flex justify-between items-center mb-2" data-id="element-2403">
                    <h3 className="font-medium text-secondary text-sm" data-id="element-2404">
                      Firewall Pusat Data
                    </h3>
                    <span className="text-xs bg-red-100 text-red-800 px-2 py-0.5 rounded-full" data-id="element-2405">
                      35%
                    </span>
                  </div>
                  <div className="h-1 w-full bg-gray-200 rounded-full mb-2" data-id="element-2406">
                    <div className="h-1 bg-red-500 rounded-full" style={{
                    width: '35%'
                  }} data-id="element-2407"></div>
                  </div>
                  <p className="text-xs text-gray-600 mb-1" data-id="element-2408">
                    Status:{' '}
                    <span className="font-medium text-accent-red" data-id="element-2409">
                      Sedang dalam pemeliharaan
                    </span>
                  </p>
                  <p className="text-xs text-gray-600" data-id="element-2410">
                    Estimasi selesai:{' '}
                    <span className="font-medium" data-id="element-2411">15 Maret 2026</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-2412">
            <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-2413">
              <h2 className="font-bold text-secondary flex items-center" data-id="element-2414">
                <CalendarIcon size={18} className="mr-2" data-id="element-2415" />
                Jadwal Pemeliharaan Mendatang
              </h2>
            </div>
            <div className="p-4" data-id="element-2416">
              <div className="space-y-3" data-id="element-2417">
                <div className="border border-gray-200 p-3 rounded-lg" data-id="element-2418">
                  <div className="flex justify-between" data-id="element-2419">
                    <div data-id="element-2420">
                      <h3 className="font-medium text-secondary text-sm" data-id="element-2421">
                        Router Backbone STIN
                      </h3>
                      <p className="text-xs text-gray-600" data-id="element-2422">15 Maret 2026</p>
                    </div>
                    <span className="text-xs bg-blue-100 text-blue-800 px-2 py-0.5 h-fit rounded-full" data-id="element-2423">
                      Terjadwal
                    </span>
                  </div>
                  <div className="text-xs text-gray-700 mt-2" data-id="element-2424">
                    <p data-id="element-2425">Vendor: PT Jaringan Aman</p>
                    <p data-id="element-2426">Estimasi biaya: Rp 8.500.000</p>
                  </div>
                </div>
                <div className="border border-gray-200 p-3 rounded-lg" data-id="element-2427">
                  <div className="flex justify-between" data-id="element-2428">
                    <div data-id="element-2429">
                      <h3 className="font-medium text-secondary text-sm" data-id="element-2430">
                        Perangkat Keamanan Jaringan STIN
                      </h3>
                      <p className="text-xs text-gray-600" data-id="element-2431">23 Maret 2026</p>
                    </div>
                    <span className="text-xs bg-blue-100 text-blue-800 px-2 py-0.5 h-fit rounded-full" data-id="element-2432">
                      Terjadwal
                    </span>
                  </div>
                  <div className="text-xs text-gray-700 mt-2" data-id="element-2433">
                    <p data-id="element-2434">Vendor: PT Keamanan Siber</p>
                    <p data-id="element-2435">Estimasi biaya: Rp 12.700.000</p>
                  </div>
                </div>
                <div className="border border-gray-200 p-3 rounded-lg" data-id="element-2436">
                  <div className="flex justify-between" data-id="element-2437">
                    <div data-id="element-2438">
                      <h3 className="font-medium text-secondary text-sm" data-id="element-2439">
                        Gedung Operasional Deputi II
                      </h3>
                      <p className="text-xs text-gray-600" data-id="element-2440">5 April 2026</p>
                    </div>
                    <span className="text-xs bg-gray-100 text-gray-800 px-2 py-0.5 h-fit rounded-full" data-id="element-2441">
                      Diajukan
                    </span>
                  </div>
                  <div className="text-xs text-gray-700 mt-2" data-id="element-2442">
                    <p data-id="element-2443">Vendor: PT Konstruksi Prima</p>
                    <p data-id="element-2444">Estimasi biaya: Rp 45.000.000</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MaintenanceFormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSubmit={handleSubmit} initialAsset={prefilledAsset} data-id="element-2445" />

      <SuccessNotification message={notification.message} isVisible={notification.show} onClose={() => setNotification({
      ...notification,
      show: false
    })} data-id="element-2446" />
    </div>;
};